import React from 'react';
import { IonToast } from '@ionic/react';

type props = {
    showToast: any ;
    setShowToast: any;
    msg: any;
};
const DURATION = 3000;
export const InfoToast = ({ showToast,setShowToast, msg }: props) => {
  return (
      <IonToast
        isOpen={showToast}
        onDidDismiss={() => setShowToast(false)}
        message={msg}
        position="top"
        animated={true}
        color="primary"
        duration={DURATION}
        header="Information"
      />
  );
};

export const SuccessToast = ({ showToast,setShowToast, msg }: props) => {
    return (
        <IonToast
          isOpen={showToast}
          onDidDismiss={() => setShowToast(false)}
          message={msg}
          position="top"
          animated={true}
          color="success"
          duration={DURATION}
          header="Success"
        />
    );
  };

  export const WarningToast = ({ showToast,setShowToast, msg }: props) => {
    return (
        <IonToast
          isOpen={showToast}
          onDidDismiss={() => setShowToast(false)}
          message={msg}
          position="top"
          animated={true}
          color="warning"
          duration={DURATION}
          header="Warning"
        />
    );
  };

  export const ErrorToast = ({ showToast,setShowToast, msg }: props) => {
    return (
        <IonToast
          isOpen={showToast}
          onDidDismiss={() => setShowToast(false)}
          message={msg}
          position="top"
          animated={true}
          color="danger"
          duration={DURATION}
          header="Error"
        />
    );
  };
